module.exports = __webpack_public_path__ + "f31ba605ca4db475532b384ce68cd417.jpg";